<template>
  <div>
    <div id="app" :style="{ maxHeight: isPhone ? '937px' : '' }" v-if="authority || authorityCookie">
      <div class="title-box">
        <h1 class="app-title">银关易数字科技服务平台</h1>
        <div class="app-times">
          <img
            class="screen"
            @click="toggleFull"
            :title="fullScreen ? '退出全屏' : '全屏'"
            :src="fullScreen ? './image/out-screen.png' : './image/screen.png'"
            width="30"
            height="30"
            :alt="fullScreen ? '退出全屏' : '全屏'"
          />
          <div style="font-size: 20px;font-weight: bold; margin-right: 20px;">{{ week }}</div>
          <div>
            <div style="font-size: 20px; margin-bottom: 10px;">{{ time }}</div>
            <div style="opacity: 0.8; font-size: 14px;">{{ day }}</div>
          </div>
        </div>
      </div>
      <div class="content" :style="{ maxHeight: isPhone ? '883px' : '' }">
        <div class="app-left">
          <marquee-text />

          <div class="rank">
            <div class="chart" style="margin-right: 10px;">
              <div class="chart-title" title="省预授信额度排行榜">省预授信额度排行榜</div>
              <rank rank-type="province" :rank-data="statistics.provinceTop10List" />
            </div>
            <div class="chart">
              <div class="chart-title" title="市预授信额度排行榜">市预授信额度排行榜</div>
              <rank rank-type="city" :rank-data="statistics.cityTop10List" />
            </div>
          </div>

          <div class="chart" style="flex: 1;">
            <div class="chart-title" title="银关易全年走势图">{{ nowyear }}年企业全年数据走势图</div>
            <analysis id-name="yearAnalysis" class="chart-item" :chart-data="statistics.currYearList || []" />
          </div>
        </div>

        <div class="app-center">
          <div class="statistics">
            <div class="statistics-item">
              <div class="statistics-item-num">{{ statistics.totalUser || 0 }}</div>
              <div class="statistics-item-text">注册用户数(家)</div>
            </div>
            <div class="statistics-item">
              <div class="statistics-item-num">{{ statistics.totalAuthCompany || 0 }}</div>
              <div class="statistics-item-text">认证企业数(家)</div>
            </div>
            <div class="statistics-item">
              <div class="statistics-item-num">{{ statistics.totalApplyCompany || 0 }}</div>
              <div class="statistics-item-text">申请企业数(家)</div>
            </div>
            <div class="statistics-item">
              <div class="statistics-item-num">{{ statistics.totalYSXCompany || 0 }}</div>
              <div class="statistics-item-text">预授信企业数(家)</div>
            </div>
          </div>

          <mapbox :rpt-list="statistics.provinceRptList" />

          <div class="top-row">
            <div class="top-row-item">
              <div class="big-font" style="margin-bottom: 10px;">{{ statistics.totalYSXAmt || 0 }}</div>
              <div>总预授信额度(万元)</div>
            </div>
            <div class="top-row-item">
              <div class="big-font" style="margin-bottom: 10px;">{{ statistics.totalActiveArea || 0 }}</div>
              <div>活跃城市数(城)</div>
            </div>
          </div>
        </div>

        <div class="app-right">
          <div class="chart app-right-chart">
            <div class="chart-title" title="银关易数据分析">{{ nowyear }}年企业{{ nowmonth }}月数据走势图</div>
            <div class="chart-top-col">
              <div>
                <p class="chart-top-col_title">注册数(家)</p>
                <p class="chart-top-col_num">{{ statistics.currMonthUser }}</p>
              </div>
              <div>
                <p class="chart-top-col_title">认证数(家)</p>
                <p class="chart-top-col_num">{{ statistics.currMonthAuthCompany }}</p>
              </div>
              <div>
                <p class="chart-top-col_title">申请数(家)</p>
                <p class="chart-top-col_num">{{ statistics.currMonthApplyCompany }}</p>
              </div>
              <div>
                <p class="chart-top-col_title">预授信数(家)</p>
                <p class="chart-top-col_num">{{ statistics.currMonthYSXCompany }}</p>
              </div>
            </div>
            <analysis id-name="analysis" class="chart-item" :chart-data="statistics.dayRptList || []" />
          </div>
          <div class="bottom-chart app-right-chart">
            <div class="chart" style="magrin-right: 20px;">
              <div class="chart-title chart-title-row" :title="`本周新增用户数(${statistics.currWeekUser})`">
                <div>本周新增用户数</div>
                <div class="chart-title-bottom">({{ statistics.currWeekUser }})</div>
              </div>

              <linechart id-name="linechart" class="chart-item" :chart-data="statistics.currWeekUserRptList || []" />
            </div>
            <div class="chart">
              <div class="chart-title chart-title-row" :title="`本周预授信额度(${statistics.currWeekYSXAmt})`">
                <div>本周预授信额度</div>
                <div class="chart-title-bottom">({{ statistics.currWeekYSXAmt }}万元)</div>
              </div>
              <histogram id-name="histogram" class="chart-item" :chart-data="statistics.currWeekYSXAmtList || []" />
            </div>
          </div>
          <div class="bottom-chart app-right-chart">
            <div class="chart" style="magrin-right: 20px;">
              <div class="chart-title chart-title-row" :title="`上周新增用户数(${statistics.lastWeekUser})`">
                <div>上周新增用户数</div>
                <div class="chart-title-bottom">({{ statistics.lastWeekUser }})</div>
              </div>
              <linechart id-name="lastlinechart" class="chart-item" :chart-data="statistics.lastWeekUserRptList || []" />
            </div>
            <div class="chart">
              <div class="chart-title chart-title-row" :title="`上周预授信额度(${statistics.lastWeekYSXAmt})`">
                <div>上周预授信额度</div>
                <div class="chart-title-bottom">({{ statistics.lastWeekYSXAmt }}万元)</div>
              </div>
              <histogram id-name="lasthistogram" class="chart-item" :chart-data="statistics.lastWeekList || []" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <password v-else type="autho" />
  </div>
</template>

<script>
import request from '@/assets/js/request';
import marqueeText from '@/components/marquee-text';
import rank from '@/components/rank';
import password from '@/components/password';
import analysis from '@/components/analysis';
import histogram from '@/components/histogram';
import linechart from '@/components/linechart';
import mapbox from '@/components/mapbox';
export default {
  name: 'spectaculars',
  components: { analysis, histogram, linechart, mapbox, password, marqueeText, rank },
  data() {
    return {
      nowyear: '',
      nowmonth: '',
      isPhone: false,
      authorityCookie: false,
      fullScreen: false,
      statistics: {},
      totalActiveArea: 0,
      totalApplyCompany: 0,
      totalAuthCompany: 0,
      totalUser: 0,
      totalYSXAmt: 0,
      totalYSXCompany: 0,
      nowDate: new Date(),
      timer: null
    };
  },
  computed: {
    authority() {
      return this.$store.state.authority;
    },
    time() {
      return `${this.timeFormat(this.nowDate.getHours())}:${this.timeFormat(this.nowDate.getMinutes())}:${this.timeFormat(
        this.nowDate.getSeconds()
      )}`;
    },
    week() {
      let weeks = new Array('星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六');
      return weeks[this.nowDate.getDay()];
    },
    day() {
      return `${this.nowDate.getFullYear()}-${this.timeFormat(this.nowDate.getMonth() + 1)}-${this.timeFormat(
        this.nowDate.getDate()
      )}`;
    }
  },
  methods: {
    timeFormat(val) {
      if (val < 10) {
        return `0${val}`;
      } else {
        return val;
      }
    },

    // 切换全屏
    toggleFull() {
      if (this.fullScreen) {
        // 退出全屏
        var exitMethod =
          document.exitFullscreen || //W3C
          document.mozCancelFullScreen || //Chrome等
          document.webkitExitFullscreen || //FireFox
          document.webkitExitFullscreen; //IE11
        if (exitMethod) {
          exitMethod.call(document);
        }
      } else {
        // 全屏
        var requestMethod =
          document.documentElement.requestFullScreen || //W3C
          document.documentElement.webkitRequestFullScreen || //Chrome等
          document.documentElement.mozRequestFullScreen || //FireFox
          document.documentElement.msRequestFullScreen; //IE11
        if (requestMethod) {
          requestMethod.call(document.documentElement);
        }
      }
      this.fullScreen = !this.fullScreen;
    },

    // 阻止F11默认事件
    keydown(event) {
      if (event.keyCode === 122) {
        event.preventDefault();
        event.returnValue = false;
      }
    },

    /**
     * 响应屏幕变化事件，给fullScreen赋值，标识是否全屏
     * IE中bug: 调试器打开，且与页面不分离时 -- 无效
     * **/
    onresize() {
      this.isPhone = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
      // 利用屏幕分辨率和window对象的内高度来判断兼容IE
      let winFlag = window.innerHeight === window.screen.height;
      // 利用window全屏标识来判断 -- IE无效
      let isFull = window.fullScreen || document.webkitIsFullScreen;

      if (isFull === undefined) {
        this.fullScreen = winFlag;
      } else {
        this.fullScreen = winFlag || isFull;
      }
    }
  },
  created() {
    this.isPhone = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);

    this.nowyear = new Date().getFullYear();
    this.nowmonth = new Date().getMonth() + 1;

    this.authorityCookie = Boolean(this.$getCookie('authority'));
    document.title = '银关易大屏数据看板';
    window.addEventListener('resize', this.onresize);
    window.addEventListener('keydown', this.keydown);
    this.timer = setInterval(() => {
      this.nowDate = new Date();
    }, 1000);
    request({ url: '/api/rpt/init' }).then(res => {
      if (res.success) {
        this.statistics = res.result;
      }
    });
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
    window.removeEventListener('keydown', this.keydown);
    window.removeEventListener('resize', this.onresize);
  }
};
</script>

<style scoped>
.chart-title-row {
  display: flex;
  flex-direction: column;
  line-height: unset !important;
  justify-content: center;
}
.chart-title-bottom {
  font-size: 14px;
  font-weight: normal;
  margin-top: 4px;
  letter-spacing: 1px;
}
</style>
